import React from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { easeOut } from '../../utils/styles';
interface ExpandProps {
  show: boolean;
  id?: string;
  children: React.ReactNode;
}
export function Expand({
  show,
  id = 'expand',
  children
}: ExpandProps) {
  const reduce = useReducedMotion();
  return <AnimatePresence initial={false} mode="wait" data-id="element-16" data-mp="1qju8mpd0za7j">
      {show && <motion.div key={id} initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: reduce ? 0 : 0.24,
      ease: easeOut
    }} className="overflow-hidden" data-id="element-17" data-mp="2e8n82vsuw06w">
          {children}
        </motion.div>}
    </AnimatePresence>;
}